// extracted by mini-css-extract-plugin
export default {"documentImage":"evsVbnffEyngi0rs7bhF"};